<template>
  <div id="app">
    <v-app>
      <v-content>
        <v-layout class="fill-viewport-height">
            <router-view />
        </v-layout>
      </v-content>
    </v-app>
  </div>
</template>


<script>
export default {
  name: "App"
};
</script>

<style lang="scss">
@import "sass/globals";

.header-grid{
  width: 100%;
  height: 50%;
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  color: white;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  font-size: 16px;
  font-family: FontBase-Regular;
  @media screen and (max-width: 600px){
    font-size: 14px;
    
  }
}
img {
  max-width: 100%;
}
.fill-viewport-height {
  height: 100vh; //Antes estaba 100% pero no funcionaba en navegadores iOS
}
p{
    font-size: 1em!important;
    line-height: 1.3em;
}

/********************  FONTS ********************/
/* Las fuentes se cargan acá porque se tiene acceso a los recursos que están en assets*/

@font-face {
  font-family: FontBase-Regular;
  src: url("./assets/fonts/Raleway-Regular.ttf");
}
@font-face {
  font-family: FontBase-SemiBold;
  src: url("./assets/fonts/ProximaNova-Bold.otf"); //no tiene Semibold
}
@font-face {
  font-family: Raleway-Regular;
  src: url("./assets/fonts/Raleway-Regular.ttf");
}
@font-face {
  font-family: Raleway-Bold;
  src: url("./assets/fonts/Raleway-Bold.ttf");;
}
@font-face {
  font-family: Raleway-Light;
  src: url("./assets/fonts/Raleway-Light.ttf"); //no tiene Bolditalic
}
@font-face {
  font-family: FontBase-Black;
  src: url("./assets/fonts/ProximaNova-Black.otf");
}
@font-face {
  font-family: FontBase-Italic;
  font-style: oblique;
  src: url("./assets/fonts/ProximaNova-Regular.otf"); //no tiene Italic
}
@font-face {
  font-family: FontBase-Medium;
  font-weight: 300;
  src: url("./assets/fonts/ProximaNova-Regular.otf"); //no tiene medium
}
@font-face {
  font-family: FontBase-MediumItalic;
  font-weight: 300;
  font-style: oblique;
  src: url("./assets/fonts/ProximaNova-Regular.otf");//no tiene MediumItalic
}

/******** IMÁGENES RETROALIMENTACIÓN BIEN Y MAL PARA DRAG N DROP **************************/
.actividad-drap-n-drop {
  .mal,
  .bien {
    position: relative;
    color: black;
    &:after {
      content: "";
      top: -12px;
      right: -12px;
      position: absolute;
      width: 25px;
      height: 25px;
      background-size: contain;
      z-index: 1;
    }
  }
}
/************* IMÁGENES DE BIEN/VISTO EN GENERAL *********************/
.cosa{
  height: 8vh;
}



.fade-enter-active, .fade-leave-active {
      transition: all 2s;
    position: absolute;
    max-height: 100%;
    min-height: 100%;
    max-width: calc(100% - 20px);
    min-width: calc(100% - 20px);
    overflow: hidden;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>

